import React from 'react';
import autobind from 'autobind-decorator';

export class StreamBankAnchorLink extends React.Component {
    constructor(props) {
        super(props);
    }

    @autobind
    onClick(e) {
        if(!this.props.Disabled) {
            let elementId = this.getHref();
            // Check "open in new window/tab" key modifiers are pressed.
            if (e.ctrlKey || e.metaKey) {
                //run event using the browser's default handling instead of our spa stuff.
                return;
            } else {
                let element = document.getElementById(elementId);
                if(element) {
                    element.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
                }
            }
        }

        e.preventDefault();
    }

    @autobind
    getHref() {
        if (this.props.Anchor) {
            return this.props.Anchor;
        }

        return "";
    }

    @autobind
    getStyle() {
        let style = {};

        if(this.props.style) {
            style = this.props.style;
        }
        if(this.props.Disabled) {
            style.cursor = "default";
        }

        return style;
    }

    render() {
        let href = this.getHref();
        let style = this.getStyle();

        return <a
            className={this.props.className}
            role={this.props.role}
            style={style}
            onClick={this.onClick}
            href={href}
        >
            {this.props.children}
        </a>;
    }
}


